<template>
  <div class="col-12 d-flex flex-wrap py-0">
    <div class="col-12 d-flex flex-wrap py-0">
      <div class="col-2 py-1">
        <Label
          :field="customerFieldsProperties('gender')"
          :value="content.gender"
          :text-color="getColorAlteredStatus('gender')"
        />
      </div>

      <div class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('firstname')"
          :value="content.firstname"
          :text-color="getColorAlteredStatus('firstname')"
        />
      </div>

      <div class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('lastname')"
          :value="content.lastname"
          :text-color="getColorAlteredStatus('lastname')"
        />
      </div>
      <div class="col-2 py-1">
        <Label
          :field="customerFieldsProperties('birth_date')"
          :value="content.birth_date"
          :text-color="getColorAlteredStatus('birth_date')"
        />
      </div>
    </div>

    <div class="col-12 d-flex flex-wrap py-0">
      <div class="col-2 py-1">
        <Label
          :field="customerFieldsProperties('street_number')"
          :value="content.street_number"
          :text-color="getColorAlteredStatus('street_number')"
        />
      </div>
      <div class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('street_name')"
          :value="content.street_name"
          :text-color="getColorAlteredStatus('street_name')"
        />
      </div>
    </div>
    <div class="col-12 d-flex flex-wrap py-0">
      <div class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('zip_code')"
          :value="content.zip_code"
          :text-color="getColorAlteredStatus('zip_code')"
        />
      </div>
      <div class="col-8 py-1">
        <Label
          :field="customerFieldsProperties('address2')"
          :value="content.address2"
          :text-color="getColorAlteredStatus('address2')"
        />
      </div>
    </div>
    <div class="col-12 d-flex flex-wrap py-0">
      <div class="col-3 py-1">
        <Label
          :field="customerFieldsProperties('town')"
          :value="content.town"
          :text-color="getColorAlteredStatus('town')"
        />
      </div>
      <div class="col-3 py-1">
        <Label
          :field="customerFieldsProperties('country')"
          :value="content.country"
          :text-color="getColorAlteredStatus('country')"
        />
      </div>
      <div class="col-3 py-1">
        <Label
          :field="customerFieldsProperties('nationality')"
          :value="content.nationality"
          :text-color="getColorAlteredStatus('nationality')"
        />
      </div>
      <div class="col-3 py-1">
        <Label
          :field="customerFieldsProperties('language')"
          :value="content.language"
          :text-color="getColorAlteredStatus('language')"
        />
      </div>
    </div>
    <div class="col-12 d-flex flex-wrap py-0">
      <div class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('email')"
          :value="content.email"
          :text-color="getColorAlteredStatus('email')"
        />
      </div>
      <div class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('telephone')"
          :value="content.telephone"
          :text-color="getColorAlteredStatus('telephone')"
        />
      </div>
      <div class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('mobilephone')"
          :value="content.mobilephone"
          :text-color="getColorAlteredStatus('mobilephone')"
        />
      </div>
    </div>
    <div class="col-12 d-flex flex-wrap py-0">
      <div class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('membershipNumber')"
          :value="content.membershipNumber"
          :text-color="getColorAlteredStatus('membershipNumber')"
        />
      </div>
      <div v-if="content.externalContextKey === 'cnous'" class="col-4 py-1">
        <Label
          :field="customerFieldsProperties('boursier')"
          :value="content.boursier"
          :text-color="getColorAlteredStatus('boursier')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { customerFieldsProperties } from '../../configs/forms';
import Label from '../forms/Label.vue';

import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: 'ClientCardViewer',
  components: { Label },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    contentAlteredValues: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {};
  },
  methods: {
    customerFieldsProperties: customerFieldsProperties,
    getColorAlteredStatus (field) {
      let color = 'black';

      if (this.contentAlteredValues && this.contentAlteredValues[field]) {
        color = 'green';
      }
      return color;
    }
  }
};
</script>

<style >
</style>
